import React, { useEffect, useContext } from "react";
import toastr from "toastr";
import { TextField, Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { appContext } from "../App";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import { Select } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";
import Autocomplete from "@material-ui/lab/Autocomplete";
import useForceUpdate from "use-force-update";
import GenericDialog from "./Dialog/GenericDialog";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  textField: {
    width: "184px",
  },
}));

const GreenCheckbox = withStyles({
  root: {
    color: blue[800],
    "&$checked": {
      color: blue[800],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const AddQuoteModal = (props) => {
  const classes = useStyles();
  const { authUser, setAuthUser } = useContext(appContext);
  const forceUpdate = useForceUpdate();
  const [quote, setQuote] = React.useState(props.initialState);
  const [purchaseDate, setPurchaseDate] = React.useState(new Date());
  const [valueDate, setValueDate] = React.useState(new Date());
  const [quotesCounter, setQuotesCounter] = React.useState(0);
  const [selectedFaceValue, setSelectedFaceValue] = React.useState(0);

  const convertToDate = (date) => {
    if (date) {
      var dd = String(date.getDate()).padStart(2, "0");
      var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = date.getFullYear();
      return dd + "/" + mm + "/" + yyyy;
    } else return "";
  };

  const getBooleanValue = (val) => {
    if (val === "T + 1") return false;
    else return true;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let num = parseFloat(selectedFaceValue);

    if (isNaN(num)) {
      toastr.warning(`Not a number of ${num}`);
      return;
    }

    if (Number.isInteger(num)) {
      let x = num;
      let y = parseFloat(quote.minimumQuantity);
      if (x > y ? x % y !== 0 : y % x !== 0) {
        toastr.warning(
          `Min. Quantity can only be in multiples of ${selectedFaceValue}`
        );
        return;
      }

      let a = num;
      let b = parseFloat(quote.maximumQuantity);
      if (a > b ? a % b !== 0 : b % a !== 0) {
        toastr.warning(
          `Max. Quantity can only be in multiples of ${selectedFaceValue}`
        );
        return;
      }
    }

    if (parseFloat(quote.maximumQuantity) < parseFloat(quote.minimumQuantity)) {
      toastr.warning("Max. Qty has to be greater than or equal to Min. Qty");
      return;
    }
    if (authUser && authUser.uuid) {
      let currentState = quote;
      currentState.purchaseDate = convertToDate(purchaseDate);
      currentState.isCurrentDay = getBooleanValue(currentState.isCurrentDay);
      currentState.isCurrentDayPurchaseDate = getBooleanValue(
        currentState.isCurrentDayPurchaseDate
      );
      if (quote.isPrivatePlacement) {
        currentState.valueDate = convertToDate(valueDate);
      }
      setQuote(props.initialState);
      setPurchaseDate(new Date());
      setValueDate(new Date());
      setSelectedFaceValue(0);
      props.onSubmit(event, currentState);
    }
  };

  useEffect(() => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: false,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      onclick: null,
      showDuration: "300",
      hideDuration: "1000",
      timeOut: "5000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
  }, []);

  const resetStateAndClose = (event, reason) => {
    event.preventDefault();
    if (reason && reason === "backdropClick") {
      return;
    }
    setQuote(props.initialState);
    props.onClose(event);
  };

  const handleChange = (event) => {
    event.persist();
    setQuote((previousValues) => ({
      ...previousValues,
      [event.target.name]: event.target.value,
    }));
  };

  function checkIfQuotesAlreadyCreatedForISIN(enteredValue) {
    setQuotesCounter(
      props.quoteIsins.filter((isin) => isin === enteredValue).length
    );
  }

  function generateInputProps() {
    let cond = quotesCounter === 1;
    return `There ${cond ? "is" : "are"} already ${quotesCounter} ${
      cond ? "quote" : "quotes"
    } created for this ISIN. Are you sure you want to proceed ?`;
  }

  const handleISINChange = (event, enteredValue) => {
    event.preventDefault();
    let currentState = quote;
    let filteredSecurityName = getFilteredSecurityName(enteredValue);
    setSelectedFaceValue(filteredSecurityName.faceValue);
    currentState.isin = enteredValue;
    if (filteredSecurityName !== undefined) {
      currentState.securityName = filteredSecurityName.securityName;
    } else currentState.securityName = "";
    setQuote(currentState);
    checkIfQuotesAlreadyCreatedForISIN(enteredValue);
    const remark = filteredSecurityName?.remarks?.toLowerCase();
    if (remark === "issue" || remark === "delisted") {
      toastr.warning(
        "The selected security has Issue or Delisted added in its remarks"
      );
    }
    forceUpdate();
  };

  const getFilteredSecurityName = (isin) => {
    return props.mappings.filter((mapping) => mapping.isin === isin)[0];
  };

  const getFilteredISIN = (securityName) => {
    return props.mappings.filter(
      (mapping) => mapping.securityName === securityName
    )[0];
  };

  const handleSecurityNameChange = (event, enteredValue) => {
    event.preventDefault();
    let currentState = quote;
    let filteredISIN = getFilteredISIN(enteredValue);
    setSelectedFaceValue(filteredISIN.faceValue);
    currentState.securityName = enteredValue;
    if (filteredISIN !== undefined) {
      currentState.isin = filteredISIN.isin;
    } else currentState.isin = "";
    setQuote(currentState);
    checkIfQuotesAlreadyCreatedForISIN(filteredISIN.isin);
    forceUpdate();
  };

  const renderSecurityNameInput = () => {
    return (
      <Grid item xs={12}>
        <Autocomplete
          id="free-solo-demo"
          freeSolo={true}
          options={props.securityNames}
          onChange={(event, enteredValue) =>
            handleSecurityNameChange(event, enteredValue)
          }
          autoHighlight={true}
          value={quote.securityName}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Security Name"
              margin="normal"
              variant="outlined"
            />
          )}
        />
      </Grid>
    );
  };

  const renderISINInput = () => {
    return (
      <Grid item xs={12}>
        <Autocomplete
          id="free-solo-demo"
          freeSolo={true}
          options={props.isinNumbers}
          onChange={(event, enteredValue) =>
            handleISINChange(event, enteredValue)
          }
          autoHighlight={true}
          value={quote.isin}
          renderInput={(params) => (
            <TextField
              {...params}
              label="ISIN"
              margin="normal"
              variant="outlined"
            />
          )}
        />
      </Grid>
    );
  };

  const handleValueDateChange = (date) => {
    setValueDate(date);
  };

  const handlePurchaseDateChange = (date) => {
    setPurchaseDate(date);
  };

  const renderPurchaseYield = () => {
    return (
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={6}>
          <TextField
            type="text"
            name="purchaseYield"
            variant="outlined"
            fullWidth
            label="Purchase Yield"
            defaultValue={quote.purchaseYield}
            onChange={(event) => {
              handleChange(event);
              const raw = event.target.value.trim();
              if (raw === "" || raw.endsWith(".")) return;
              if ((raw.match(/\d/g) || []).length < 2 && !raw.includes("."))
                return;
              const v = Number(raw);
              if (!Number.isNaN(v) && v > 16) {
                toastr.warning("Purchase Yield should be less than 16");
              }
            }}
            helperText={<span style={{ color: "red" }}>Upto 16</span>}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            type="text"
            name="purchasePrice"
            variant="outlined"
            fullWidth
            label="Purchase Price"
            defaultValue={quote.purchasePrice}
            onChange={(event) => {
              handleChange(event);
              const raw = event.target.value.trim();
              if (raw === "" || raw.endsWith(".")) return;
              if ((raw.match(/\d/g) || []).length < 2 && !raw.includes("."))
                return;
              const value = Number(raw);
              if (!Number.isNaN(value) && value < 90) {
                toastr.warning("Purchase Price should be more than 90");
              }
            }}
            helperText={<span style={{ color: "red" }}>Above 90</span>}
          />
        </Grid>
      </Grid>
    );
  };

  const renderMinAndMaxQuantity = () => {
    return (
      <Grid container item xs={12} spacing={1}>
        <React.Fragment>
          <Grid item xs={6} style={{ "margin-top": "10px" }}>
            <TextField
              type="text"
              name="minimumQuantity"
              variant="outlined"
              fullWidth
              label="Minimum Quantity"
              defaultValue={quote.minimumQuantity}
              onChange={(event) => handleChange(event)}
            />
          </Grid>
          <Grid item xs={6} style={{ "margin-top": "10px" }}>
            <TextField
              type="text"
              name="maximumQuantity"
              variant="outlined"
              fullWidth
              label="Maximum Quantity"
              defaultValue={quote.maximumQuantity}
              onChange={(event) => handleChange(event)}
            />
          </Grid>
        </React.Fragment>
      </Grid>
    );
  };

  const renderPurchaseDateAndPurchasePrice = () => {
    let purchaseDateOptions = [
      "T + 0",
      "T + 1",
      "T + 2",
      "T + 3",
      "T + 4",
      "T + 5",
      "T + 6",
      "T + 7",
    ];
    return (
      <Grid container item xs={12} spacing={1}>
        <React.Fragment>
          <Grid item xs={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid item justify="space-around" xs={8}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label="Purchase Date"
                  format="dd/MM/yyyy"
                  value={purchaseDate}
                  onChange={handlePurchaseDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={6} style={{ "margin-top": "10px" }}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              style={{ width: "100%" }}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                Purchase Date T+0/T+1
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                name="isCurrentDayPurchaseDate"
                value={quote.isCurrentDayPurchaseDate}
                onChange={(event) => handleChange(event)}
                label="T+0/T+1"
              >
                {purchaseDateOptions &&
                  purchaseDateOptions.length > 0 &&
                  purchaseDateOptions.map((purchaseDateOption, index) => {
                    return (
                      <MenuItem value={purchaseDateOption} key={index}>
                        {purchaseDateOption}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>
        </React.Fragment>
      </Grid>
    );
  };

  const renderSpread = () => {
    return (
      <TextField
        style={{ "margin-top": "10px" }}
        type="text"
        name="spread"
        variant="outlined"
        fullWidth
        label="Spread"
        defaultValue={quote.spread}
        onChange={(event) => handleChange(event)}
      />
    );
  };

  const renderIsCurrentDayDropdown = () => {
    let currentDayOptions = [
      "T + 0",
      "T + 1",
      "T + 2",
      "T + 3",
      "T + 4",
      "T + 5",
      "T + 6",
      "T + 7",
    ];

    return (
      <Grid container item xs={12} spacing={1}>
        {quote.isPrivatePlacement ? (
          renderValueDate()
        ) : (
          <Grid item xs={6} style={{ "margin-top": "10px" }}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              style={{ width: "100%" }}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                T+0/T+1
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                name="isCurrentDay"
                value={quote.isCurrentDay}
                onChange={(event) => handleChange(event)}
                label="T+0/T+1"
              >
                {currentDayOptions &&
                  currentDayOptions.length > 0 &&
                  currentDayOptions.map((currentDayOption, index) => {
                    return (
                      <MenuItem value={currentDayOption} key={index}>
                        {currentDayOption}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>
    );
  };

  const handleCheckBox = (event) => {
    event.persist();
    setQuote((previousValues) => ({
      ...previousValues,
      [event.target.name]: event.target.checked,
    }));
  };

  const renderValueDate = () => {
    if (quote.isPrivatePlacement) {
      return (
        <Grid item xs={6}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid item justify="space-around" xs={8}>
              <KeyboardDatePicker
                margin="normal"
                id="date-picker-dialog"
                label="Value Date"
                format="dd/MM/yyyy"
                value={valueDate}
                onChange={handleValueDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
      );
    } else return "";
  };

  const renderCheckboxes = () => {
    return (
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={6} style={{ "margin-top": "10px" }}>
          <FormControlLabel
            control={
              <GreenCheckbox
                checked={quote.isBookStock}
                onChange={handleCheckBox}
                name="isBookStock"
              />
            }
            label="Price Drop"
          />
        </Grid>
        <Grid item xs={6} style={{ "margin-top": "10px" }}>
          <FormControlLabel
            control={
              <GreenCheckbox
                checked={quote.isHotDeal}
                onChange={handleCheckBox}
                name="isHotDeal"
              />
            }
            label="Active Deal"
          />
        </Grid>
        <Grid item xs={6} style={{ "margin-top": "10px" }}>
          <FormControlLabel
            control={
              <GreenCheckbox
                checked={quote.isPrivatePlacement}
                onChange={handleCheckBox}
                name="isPrivatePlacement"
              />
            }
            label="Is Private Placement"
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <div>
      <Dialog
        open={props.show}
        onClose={(event, reason) => resetStateAndClose(event, reason)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Add Quote</DialogTitle>
        <DialogContent style={{ width: "500px" }}>
          <DialogContentText id="alert-dialog-description">
            {renderISINInput()}
            {renderSecurityNameInput()}
            {renderPurchaseDateAndPurchasePrice()}
            {renderPurchaseYield()}
            {renderSpread()}
            {renderMinAndMaxQuantity()}
            {renderIsCurrentDayDropdown()}
            {renderCheckboxes()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(event, reason) => resetStateAndClose(event, reason)}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={(event) => handleSubmit(event)}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {quotesCounter > 0 ? (
        <GenericDialog
          show={quotesCounter > 0}
          heading="Create Duplicate Quotes ?"
          inputProps={generateInputProps()}
          onClose={(event) => {
            setQuotesCounter(0);
            resetStateAndClose(event, "");
          }}
          handleSubmit={() => {
            setQuotesCounter(0);
          }}
          submitButtonText="Proceed anyway"
          cancelButtonText="No, I dont want to proceed"
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default AddQuoteModal;
